var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1B154BA6-E658-44F9-AC5C-267C059A2D3D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(-811.000000, -467.000000)",
    fill: "#5A5B5B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hide-password",
    transform: "translate(811.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-(1)",
    transform: "translate(0.000000, 2.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8474219,7.04455793 C23.6330156,6.75841463 18.5244375,0.0381859756 11.9998594,0.0381859756 C5.47528125,0.0381859756 0.36646875,6.75841463 0.152296875,7.04428354 C-0.050765625,7.31574695 -0.050765625,7.68393293 0.152296875,7.95539634 C0.36646875,8.24153963 5.47528125,14.9617683 11.9998594,14.9617683 C18.5244375,14.9617683 23.6330156,8.2414939 23.8474219,7.955625 C24.0507656,7.68420732 24.0507656,7.31574695 23.8474219,7.04455793 Z M11.9998594,13.4179573 C7.1938125,13.4179573 3.03126563,8.95760671 1.7990625,7.49945122 C3.02967188,6.04001524 7.1835,1.58199695 11.9998594,1.58199695 C16.8056719,1.58199695 20.9679375,6.04157012 22.2006563,7.50050305 C20.9700469,8.95989329 16.8162187,13.4179573 11.9998594,13.4179573 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998594,2.86852134 C9.38226563,2.86852134 7.25259375,4.94625 7.25259375,7.5 C7.25259375,10.05375 9.38226562,12.1314787 11.9998594,12.1314787 C14.6174531,12.1314787 16.747125,10.05375 16.747125,7.5 C16.747125,4.94625 14.6174531,2.86852134 11.9998594,2.86852134 Z M11.9998594,10.587622 C10.2547031,10.587622 8.83504687,9.20254573 8.83504687,7.5 C8.83504687,5.79745427 10.25475,4.41237805 11.9998594,4.41237805 C13.7449687,4.41237805 15.1646719,5.79745427 15.1646719,7.5 C15.1646719,9.20254573 13.7450156,10.587622 11.9998594,10.587622 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 0.8,
    transform: "translate(12.015611, 9.015611) rotate(45.000000) translate(-12.015611, -9.015611) ",
    x: -0.38438854,
    y: 7.86561146,
    width: 24.8,
    height: 2.3,
    rx: 0.75
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.7a6338ae41cb3ac83b54ae4b816178db.svg";
export { ForwardRef as ReactComponent };